import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "match-greater-2",
  "use": "match-greater-2-usage",
  "viewBox": "0 0 59.39 138.98",
  "content": "<symbol viewBox=\"0 0 59.39 138.98\" id=\"match-greater-2\"><path class=\"a\" d=\"M44.58 124.49H31V84.61a2.33 2.33 0 0 0 .15-.84v-5.58A2.09 2.09 0 0 0 29 76.05H2.14A2.09 2.09 0 0 0 0 78.18v5.6a2.08 2.08 0 0 0 2.14 2.12H19.7v46.3a2.09 2.09 0 0 0 2.13 2.14h22.75V139l14.81-9.43-14.81-9.43zM44.58 0v5.14H21.81a2.09 2.09 0 0 0-2.13 2.14v46.3H2.14A2.08 2.08 0 0 0 0 55.7v5.6a2.09 2.09 0 0 0 2.14 2.13H29a2.09 2.09 0 0 0 2.13-2.13v-5.58a2.35 2.35 0 0 0-.15-.85V15h13.6v3.87l14.81-9.44z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/match-greater-2.svg
// module id = BJcX
// module chunks = 1